import { render, staticRenderFns } from "./ProductsListCard.vue?vue&type=template&id=e9fd4ae2"
import script from "./ProductsListCard.vue?vue&type=script&lang=js"
export * from "./ProductsListCard.vue?vue&type=script&lang=js"
import style0 from "./ProductsListCard.vue?vue&type=style&index=0&id=e9fd4ae2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports